import { useAutoAddPickToBetslip } from "../../hooks/useAutoAddPickToBetslip";
import type { ProcessedSelection } from "@/hooks/firestore/betting/useEntries";
import type { MysteryMulti } from "@/features/sem-generator/util/constants";

type ShareAddToBetslipProps = {
  onPickAddedToBetslip: () => void;
  selection: ProcessedSelection;
  mysteryMulti?: MysteryMulti;
};

const ShareAddToBetslip = ({
  onPickAddedToBetslip,
  selection,
  mysteryMulti,
}: ShareAddToBetslipProps) => {
  useAutoAddPickToBetslip(selection, true, onPickAddedToBetslip, mysteryMulti);

  return null;
};

export { ShareAddToBetslip };
